(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxury-related-products')) {
    customElements.define(
      'luxury-related-products',
      class extends HTMLElement {
        connectedCallback() {
          if (this.querySelector('[data-related-content]')) {
            this.hidden = false;
            return;
          }

          if (this.loading) return;
          this.loadRecommendations();
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.loading = false;
        }

        async loadRecommendations() {
          const url = this.dataset.url;
          if (!url) return;

          this.loading = true;

          const controller = new AbortController();
          this.controller = controller;

          try {
            const response = await fetch(url, {
              signal: controller.signal
            });

            if (!response.ok) {
              throw new Error('Recommendations could not be loaded.');
            }

            const html = await response.text();

            if (controller.signal.aborted || !this.isConnected) return;

            const parsed = new DOMParser().parseFromString(
              html,
              'text/html'
            );

            const content = parsed.querySelector(
              'luxury-related-products [data-related-content]'
            );

            if (content && content.querySelector('.luxury-related__card')) {
              this.replaceChildren(document.importNode(content, true));
              this.hidden = false;
            } else {
              this.hidden = true;
            }
          } catch (error) {
            if (error.name !== 'AbortError') {
              this.hidden = true;
            }
          } finally {
            if (this.controller === controller) {
              this.loading = false;
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-luxury"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxury-main-product')) {
    customElements.define('luxury-main-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.clickHandler = this.onClick.bind(this);
        this.changeHandler = this.onChange.bind(this);
        this.keyHandler = this.onKey.bind(this);

        this.addEventListener('click', this.clickHandler);
        this.addEventListener('change', this.changeHandler);
        this.addEventListener('keydown', this.keyHandler);

        const button = this.querySelector('[data-save-product]');
        if (button) {
          button.setAttribute(
            'aria-pressed',
            this.saved().includes(this.dataset.productId) ? 'true' : 'false'
          );
        }

        const dialog = this.querySelector('dialog');
        if (dialog && !dialog.dataset.bound) {
          dialog.dataset.bound = 'true';
          dialog.addEventListener('close', () => this.zoomTrigger?.focus());
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.removeEventListener('click', this.clickHandler);
        this.removeEventListener('change', this.changeHandler);
        this.removeEventListener('keydown', this.keyHandler);
        this.ready = false;
      }

      saved() {
        try {
          const values = JSON.parse(
            localStorage.getItem('luxury-product-wishlist') || '[]'
          );
          return Array.isArray(values) ? values : [];
        } catch {
          return [];
        }
      }

      showMedia(id) {
        this.querySelectorAll('[data-media]').forEach(slide => {
          slide.hidden = slide.dataset.media !== id;

          if (slide.hidden) {
            slide.querySelectorAll('video').forEach(video => video.pause());
            slide.querySelectorAll('iframe').forEach(frame => {
              if (frame.src) frame.src = frame.src;
            });
          }
        });

        this.querySelectorAll('[data-target]').forEach(button => {
          button.setAttribute(
            'aria-pressed',
            button.dataset.target === id ? 'true' : 'false'
          );
        });
      }

      checkPin() {
        const box = this.querySelector('[data-delivery]');
        if (!box) return;

        const input = box.querySelector('[data-pin]');
        const status = box.querySelector('[data-pin-status]');
        const pin = input.value.trim();
        const valid = /^[1-9][0-9]{5}$/.test(pin);

        input.setAttribute('aria-invalid', valid ? 'false' : 'true');

        if (!valid) {
          status.textContent = 'Please enter a valid 6-digit Indian PIN code.';
          return;
        }

        const pins = box.dataset.pincodes
          .split(/[\s,;]+/)
          .filter(value => /^[1-9][0-9]{5}$/.test(value));

        status.textContent = !pins.length
          ? 'Confirm delivery availability and charges at checkout.'
          : pins.includes(pin)
            ? 'This PIN code is in our delivery list. Final availability is confirmed at checkout.'
            : 'This PIN code is not in our configured list. Please contact us to confirm.';
      }

      onClick(event) {
        const target = event.target.closest('button, a');
        if (!target) return;

        if (target.hasAttribute('data-target')) {
          this.showMedia(target.dataset.target);
        }

        if (target.hasAttribute('data-direction')) {
          const slides = [...this.querySelectorAll('[data-media]')];
          if (!slides.length) return;

          const current = slides.findIndex(slide => !slide.hidden);
          const next = (
            current + Number(target.dataset.direction) + slides.length
          ) % slides.length;

          this.showMedia(slides[next].dataset.media);
        }

        if (target.hasAttribute('data-zoom')) {
          event.preventDefault();
          this.zoomTrigger = target;

          const dialog = this.querySelector('dialog');
          const image = dialog.querySelector('[data-zoom-image]');

          image.src = target.href;
          image.alt = target.querySelector('img')?.alt || '';
          dialog.showModal();
        }

        if (target.hasAttribute('data-close-zoom')) {
          this.querySelector('dialog').close();
        }

        if (target.hasAttribute('data-check-pin')) {
          this.checkPin();
        }

        if (target.hasAttribute('data-save-product')) {
          const values = this.saved();
          const id = this.dataset.productId;
          const adding = !values.includes(id);
          const status = this.querySelector('[data-save-status]');

          try {
            localStorage.setItem(
              'luxury-product-wishlist',
              JSON.stringify(
                adding ? [...values, id] : values.filter(value => value !== id)
              )
            );

            target.setAttribute('aria-pressed', adding ? 'true' : 'false');
            status.textContent = adding
              ? 'Product saved on this device.'
              : 'Product removed from saved items.';
          } catch {
            status.textContent = 'Browser storage is unavailable.';
          }
        }
      }

      onKey(event) {
        if (event.target.matches('[data-pin]') && event.key === 'Enter') {
          event.preventDefault();
          this.checkPin();
        }

        if (event.key === 'Escape') {
          this.querySelectorAll('.lmp__offer[open]').forEach(offer => {
            offer.open = false;
          });
        }
      }

      async onChange(event) {
        if (!event.target.matches('[data-option]')) return;

        const values = [...this.querySelectorAll('[data-option]:checked')]
          .map(input => input.value);

        const url = new URL(
          event.target.dataset.productUrl || this.dataset.url,
          location.origin
        );

        url.searchParams.set('option_values', values.join(','));

        if (url.pathname !== new URL(this.dataset.url, location.origin).pathname) {
          location.assign(url.toString());
          return;
        }

        const pageURL = url.toString();
        url.searchParams.set('section_id', this.dataset.section);

        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;

        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[type="submit"]').forEach(button => {
          button.disabled = true;
        });

        this.querySelector('[data-variant-status]').textContent =
          'Updating product options.';

        const selectedValue = event.target.value;

        try {
          const response = await fetch(url.toString(), {
            signal: controller.signal
          });

          if (!response.ok) throw new Error('Product update failed.');

          const html = await response.text();
          if (controller.signal.aborted || !this.isConnected) return;

          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const replacement = parsed.querySelector('luxury-main-product');

          if (!replacement) throw new Error('Product section missing.');

          this.replaceWith(replacement);
          history.replaceState({}, '', pageURL);

          replacement.querySelector(
            '[data-option][value="' + CSS.escape(selectedValue) + '"]'
          )?.focus({ preventScroll: true });

          window.Shopify?.PaymentButton?.init();
        } catch (error) {
          if (error.name !== 'AbortError') location.assign(pageURL);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
